import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { EventDetailProvider, eventDetailSubviews } from '../../pages/MyIcsc/Events/EventDetailProvider';
import colors from '@general/colors';
import CalendarPlusIcon from '@icons/CalendarPlusIcon';
import { LinkText } from '@styled';

const Container = styled.div`
    align-items: center;
    background: ${colors.brightSunTint};
    display: flex;
    padding: 8px 16px;
`;

const EventAgendaCTA = () => {
    const { event, setCurrentSubview } = useContext(EventDetailProvider);
    const history = useHistory();

    return (
        <Container>
            <CalendarPlusIcon />

            <LinkText className="ml-0.5rem text-ultra-dark-gray">
                Make the most of this event by connecting with other attendees.{' '}
                {/*
                <a
                    href="#"
                    className="text-primary"
                    onClick={(e) => {
                        e.preventDefault();
                        setCurrentSubview(eventDetailSubviews.AVAILABILITY.key);
                        window.history.replaceState(null, '', `/my-icsc/events/${event.event_code}/availability`);
                    }}
                >
                    Set your availability
                </a>{' '}
                and{' '}
                */}
                <a
                    href="#"
                    className="text-primary"
                    onClick={e => {
                        e.preventDefault();
                        history.push(`/my-icsc/connections/matches`);
                    }}
                >
                    Explore your matches
                </a>
                .
            </LinkText>
        </Container>
    );
};

export default EventAgendaCTA;
